const ForeignerAuthenticationDefaultSteps={
    CREATE_PAYMENT:'CreatePayment',
    PAYMENT_INQUIRY:'InquiryPayment',
    INIT_CONFIRM:'InitConfirm',
    UNIQUE_FACE:"UniqueFace",
    FOREIGNER_DOCUMENT_READER:"ForeignDocumentReader",
    FINAL:"Final",

}
const DefaultTexts = {
    "InitConfirm":{
        title:"تکمیل اطلاعات"
    },
    "CreatePayment":{
        title:"پرداخت"
    },
    "PaymentInquiry":{
        title:"پرداخت"
    },
    "NIDCardReader": {
        title:"عکس کارت ملی"
    },
    "Shahkar": {
        title:"ساخت فرایند جدید"
    },
    "CompareFaces": {
        title:"احراز هویت تصویری"
    },
    "VideoValidation": {
        title:"احراز هویت ویدیویی"
    },

};

export {ForeignerAuthenticationDefaultSteps,DefaultTexts}